import { useRef, useEffect, useState } from 'react';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';

import { Alert } from 'components/common/error/components/Alert';
import {
  ResidentialSupplyAddress422Error,
  ResidentialNonSupplyAddress422Error
} from 'components/common/error/components/ResidentialBankAccount422Error';
import { ComercialBankAccount422Error } from 'components/common/error/components/ComercialBankAccount422Error';
import { SessionError } from 'components/common/error/components/SessionError';
import { BankAccountMaxAttempts422Error } from 'components/common/error/components/BankAccountMaxAttempts422Error';
import { MoveInPreSSDError } from 'components/common/error/components/MoveInPreSSDError';
import { MeterReadTolleranceError } from 'components/common/error/components/MeterReadTolleranceError';
import {
  MeterReadAgentHandOffError,
  MeterReadMaxAttemptsError
} from 'components/common/error/components/MeterReadContactError';

const AlertComponents = {
  Alert,
  ResidentialSupplyAddress422Error,
  ResidentialNonSupplyAddress422Error,
  ComercialBankAccount422Error,
  SessionError,
  BankAccountMaxAttempts422Error,
  MoveInPreSSDError,
  MeterReadTolleranceError,
  MeterReadAgentHandOffError,
  MeterReadMaxAttemptsError
};

export const testId = 'errorTestId';

type ErrorType = {
  message?: string;
  title?: string;
  messageForAgent?: string;
  name?: string;
};

type ErrorProps = {
  errors: ErrorType[];
};

export const Error = ({ errors }: ErrorProps) => {
  const [scrolled, setScrolled] = useState(false);
  const hasErrors = errors && errors.length;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scrolled && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
      setScrolled(true);
    }
  }, [scrolled]);

  if (!hasErrors) {
    return null;
  }

  return (
    <div data-testid={testId} id="errors" ref={ref}>
      <NsColumn>
        {errors.map(({ message, title = 'Error', name, ...rest }, index) => {
          const AlertComponent =
            name && AlertComponents[name]
              ? AlertComponents[name]
              : AlertComponents.Alert;
          return (
            <AlertComponent
              key={index}
              title={title}
              message={message}
              {...rest}
            />
          );
        })}
      </NsColumn>
    </div>
  );
};
